import { useState, useEffect } from 'react'

export default function ScrollButton({ children }) {
  const [scrollPosition, setScrollPosition] = useState(0)

  const showUnder = 160

  const handleScroll = () => {
    setScrollPosition(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
  }, [])

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0 })
  }

  return (
    scrollPosition >= showUnder && (
      <div className="scroll-button" onClick={handleScrollToTop}>
        {children}
      </div>
    )
  )
}
